export const server_address = import.meta.env.VITE_BACKEND;
export const BASEDOMAIN = `${server_address}api/v2`;

export const FEDOMAIN = import.meta.env.VITE_ORIGIN;
export const USER_PORTAL_ADDRESS =
    import.meta.env.VITE_USER_PORTAL_ORIGIN;

export const APPNAME = 'GreenSign';

export const E_K1 = import.meta.env.VITE_E_K1;
export const E_K2 = import.meta.env.VITE_E_K2;

export const AZURE_CONSENT_URL = (tenant_id, state) =>
    `https://login.microsoftonline.com/${tenant_id}/adminconsent?client_id=${
        import.meta.env.VITE_CLIENT_ID
    }&redirect_uri=${USER_PORTAL_ADDRESS}redirect&state=${state}`;

export const IS_DISPOSABLE_EMAIL_ALLOWED =
    import.meta.env.VITE_IS_DISPOSABLE_EMAIL_ALLOWED === 'true';

const isRecaptchaSiteKey = (key) =>
    typeof key === 'string' && key.startsWith('6L');

export const RECAPTCHA_V2_SITE_KEY =
    import.meta.env.VITE_RECAPTCHA_V2_SITE_KEY;

export const RECAPTCHA_V3_SITE_KEY =
    import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY;

export const IS_CAPTCHA_ENABLED =
    import.meta.env.VITE_IS_CAPTCHA_ENABLED === 'true' &&
    (isRecaptchaSiteKey(RECAPTCHA_V3_SITE_KEY) ||
        isRecaptchaSiteKey(RECAPTCHA_V2_SITE_KEY));

const logRocketAppId = import.meta.env.VITE_LOGROCKET_APP_ID;
export const LOGROCKET_APP_ID =
    logRocketAppId && logRocketAppId.includes('/') ? logRocketAppId : '';

export const CURRENT_BUILD_VERSION =
    import.meta.env.VITE_CURRENT_BUILD_VERSION;

export const MINIMUM_BUILD_VERSION =
    import.meta.env.VITE_MINIMUM_BUILD_VERSION;
